export enum Gender {
    MALE = "Männlich",
    FEMALE = "Weiblich",
    DIVERS = "Divers"
}
